import useSWR from 'swr';

import useCache from '../../../../Components/Context/Hooks/useCache';
import { ProjectsInfo } from '../../../../Types/api';
import { Project } from '../../../../Types/project';
import { getStatusCode } from '../../../../Utils/errors';
import { HTTP_STATUS_CODES } from '../../../../Utils/errors/NetworkError';

interface Result {
  loading: boolean;
  error: any | null;
  project?: Project;
}

const useProject = (projectId: string): Result => {
  const { getValue } = useCache((projectId: string): [string, RequestInit] => [
    '/projects.info',
    { body: JSON.stringify({ id: projectId }) },
  ]);
  const { data, error } = useSWR<ProjectsInfo>(getValue(projectId));
  const project = getStatusCode(error) === HTTP_STATUS_CODES.NOT_FOUND ? undefined : data?.data;

  if (!data && !error) {
    return { loading: true, error: null, project };
  }

  return { loading: false, error: error ?? null, project };
};

export default useProject;
